module.exports = __webpack_public_path__ + "img/logo_pro.5b3ca3d1.png";